"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setRuntimeConfig = setRuntimeConfig;
exports.getRuntimeConfig = getRuntimeConfig;

var _extend = _interopRequireDefault(require("lodash/extend"));

var runTimeConfig;

if (typeof window !== 'undefined') {
  runTimeConfig = window.runtimeConfig;
} // modify process env to new style


if (!runTimeConfig) {
  var _process;

  runTimeConfig = (_process = process) === null || _process === void 0 ? void 0 : _process.env;
  var currentEnv = runTimeConfig._env;

  if (runTimeConfig._urls) {
    var defaultUrls = runTimeConfig._urls["default"] || runTimeConfig._urls || {};
    runTimeConfig._urls = (0, _extend["default"])(defaultUrls, runTimeConfig._urls[currentEnv]);
  }

  runTimeConfig._apiKeys = runTimeConfig._apiKeys ? runTimeConfig._apiKeys[currentEnv] : {};
}

function setRuntimeConfig(config) {
  runTimeConfig = config;
}

function getRuntimeConfig() {
  if (runTimeConfig.version === 2) {
    return runTimeConfig;
  }

  if (!runTimeConfig._brandVariables) {
    runTimeConfig._brandVariables = require('brand_variables_js')["default"];
  }

  if (!runTimeConfig._brandImages) {
    runTimeConfig._brandImages = require('brand_logo');
  }

  return runTimeConfig;
}